import { Component, OnInit } from "@angular/core";
import { Title } from "@angular/platform-browser";
import { environment } from "../../environments/environment";
import { isEnglish } from "./current-language";

@Component({
  selector: "app-social-housing-calculator",
  templateUrl: "./social-housing-calculator.component.html",
  styleUrls: ["./social-housing-calculator.component.scss"],
})
export class SocialHousingCalculatorComponent implements OnInit {
  public canCancel = false;
  public lastUpdate: Date;

  public isEn = isEnglish();
  public ruleLink = isEnglish()
    ? environment.linkRulesEn
    : environment.linkRulesFr;
  public helpLink = isEnglish()
    ? environment.linkHelpEn
    : environment.linkHelpFr;
  public homeLink = isEnglish()
    ? environment.linkHomeEn
    : environment.linkHomeFr;
  public servicesLink = isEnglish()
    ? environment.linkServicesEn
    : environment.linkServicesFr;
  public toolsLink = isEnglish()
    ? environment.linkToolsEn
    : environment.linkToolsFr;
  public gridLink = environment.gridLink;

  constructor(private titleService: Title) {}

  public ngOnInit() {
    this.lastUpdate = new Date();
    if (this.isEn) {
      this.titleService.setTitle(
        "Calculation tool: Contributions for social or affordable off-market housing and family housing",
      );
    } else {
      this.titleService.setTitle(
        "Outil de calcul : contributions pour logements sociaux ou abordables hors-marché et logements familiaux",
      );
    }
  }

  public onPrint() {
    window.print();
  }
}
